import styled from 'styled-components';

export const ViewWrapper = styled.div`
  height: 700px;
  width: 100%;
  background: ${(props) => props.theme.colors.tableCell};
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.stroke};

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ImageView = styled.div`
  @media screen and (max-width: 1000px) {
    min-width: auto;
  }

  min-width: 464px;

  svg {
    width: 100%;
  }
`;
